"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var reactLifecyclePolyfill = require("react-lifecycles-compat");

var children_1 = require("../utils/children");

var Fragment = React.Fragment;

var PoseGroup = function (_super) {
  __extends(PoseGroup, _super);

  function PoseGroup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      incomingChildren: [],
      isLeaving: new Set(),
      removeFromTree: function removeFromTree(key) {
        return function () {
          var isLeaving = _this.state.isLeaving;
          isLeaving.delete(key);

          _this.removeFromChildren(key);
        };
      }
    };
    return _this;
  }

  PoseGroup.prototype.removeFromChildren = function (key) {
    var children = this.state.children;
    this.setState({
      children: children_1.removeFromChildren(children, key)
    });
  };

  PoseGroup.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    return this.state !== nextState;
  };

  PoseGroup.prototype.render = function () {
    var children = this.state.children;
    return React.createElement(Fragment, null, children);
  };

  PoseGroup.defaultProps = {
    flipMove: true,
    preEnterPose: 'exit',
    enterPose: 'enter',
    exitPose: 'exit',
    singleChildOnly: false
  };

  PoseGroup.getDerivedStateFromProps = function (props, _a) {
    var isLeaving = _a.isLeaving,
        removeFromTree = _a.removeFromTree,
        children = _a.children;
    var incomingChildren = children_1.makeChildList(props.children);
    return {
      incomingChildren: incomingChildren,
      children: children_1.handleIncomingChildren(__assign({}, props, {
        incomingChildren: incomingChildren,
        displayedChildren: children,
        isLeaving: isLeaving,
        removeFromTree: removeFromTree
      }))
    };
  };

  return PoseGroup;
}(React.Component);

exports.PoseGroup = PoseGroup;
reactLifecyclePolyfill(PoseGroup);